import { MutationTree } from 'vuex';
import { TimeZone, TimeZoneState } from './types';
import * as types from './mutation-types';

export const mutations: MutationTree<TimeZoneState> = {
    // システム設定取得系
    [types.INDEX_START](state) {
        const indexState = state.index;
        indexState.error = false;
        indexState.errorCode = undefined;
        indexState.errorMsg = undefined;
        indexState.isProcessing = true;
        indexState.isFetchSuccess = false;
    },

    [types.INDEX_SUCCESS](state, payload: { time_zone: Array<TimeZone> }) {
        state.timeZone = payload.time_zone;

        const indexState = state.index;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = true;
    },

    [types.INDEX_FAILURE](state, payload: { code: string; message: string }) {
        const indexState = state.index;
        indexState.errorCode = payload.code;
        indexState.errorMsg = payload.message;
        indexState.error = true;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const indexState = state.index;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    [types.CLEAR_ALL](state) {
        state.timeZone = undefined;

        const indexState = state.index;
        indexState.error = false;
        indexState.errorCode = undefined;
        indexState.errorMsg = undefined;
        indexState.isProcessing = true;
        indexState.isFetchSuccess = false;
    },
};
